"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIN_WIDTH = exports.MIN_WIDE_CARD_WIDTH = exports.MIN_TWO_COLUMNS_CONTAINER_WIDTH = exports.MIN_DESKTOP_WIDTH = exports.MIN_DESKTOP_CIGARETTE_WIDTH = exports.MAX_WIDTH = exports.LT_DOMAIN = exports.DEFAULT_KID_AGE = exports.AVG_HOTELCARD_HEIGHT = void 0;
var MIN_WIDTH = 320;
exports.MIN_WIDTH = MIN_WIDTH;
var MIN_DESKTOP_WIDTH = 640;
exports.MIN_DESKTOP_WIDTH = MIN_DESKTOP_WIDTH;
var MIN_TWO_COLUMNS_CONTAINER_WIDTH = 944;
exports.MIN_TWO_COLUMNS_CONTAINER_WIDTH = MIN_TWO_COLUMNS_CONTAINER_WIDTH;
var MIN_WIDE_CARD_WIDTH = 459;
exports.MIN_WIDE_CARD_WIDTH = MIN_WIDE_CARD_WIDTH;
var MIN_DESKTOP_CIGARETTE_WIDTH = 756;
exports.MIN_DESKTOP_CIGARETTE_WIDTH = MIN_DESKTOP_CIGARETTE_WIDTH;
var MAX_WIDTH = 1100;
exports.MAX_WIDTH = MAX_WIDTH;
var AVG_HOTELCARD_HEIGHT = 350;
exports.AVG_HOTELCARD_HEIGHT = AVG_HOTELCARD_HEIGHT;
var LT_DOMAIN = 'level.travel';
exports.LT_DOMAIN = LT_DOMAIN;
var DEFAULT_KID_AGE = 7;
exports.DEFAULT_KID_AGE = DEFAULT_KID_AGE;